import Base from './Base';
import CannedMessage from '../models/CannedMessage';

export default class CannedMessages extends Base {
    get models() {
        const collection = this.data.map(item => new CannedMessage(item));
        collection.collection = this;

        return collection;
    }
}